import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/android.svg'
import _imports_1 from '@/assets/images/ios.svg'


const _withScopeId = n => (_pushScopeId("data-v-3970d8d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-list-counter p-d-flex" }
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "android" }, "Android", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "img",
  style: {"color":"#162020","margin-left":"10px"}
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "android" }, "iOS", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { style: {"margin-left":"10vw"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "counter" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Total Installs iOS", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "counter" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Total Installs Android", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ask_hint = _resolveComponent("ask-hint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-d-flex", [_ctx.showIos===true ? 'opacity' : '']]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showAndroid= true; _ctx.showIos=false})
      }, [
        _hoisted_3,
        _hoisted_4,
        _createTextVNode(" / ")
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-d-flex", [_ctx.showAndroid===true ? 'opacity' : '']]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showAndroid= false; _ctx.showIos=true})
      }, _hoisted_7, 2),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_ask_hint, { class: "hint" })
      ])
    ]),
    (_ctx.showIos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.ios), 1),
          _hoisted_11
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAndroid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.android), 1),
          _hoisted_14
        ]))
      : _createCommentVNode("", true)
  ]))
}